import { createReducer } from './../commons/js/utils/reducer';

const initialState = {
    currentPage: 1,
    pageCount: 1,
    activeFacilityList: [],
    selectedFacility: { value: null, label: '' },
    selectedReviewFilter: {label: "All", value: null, filter: null, type: null},
}

export const pmDashboardReducer = createReducer(initialState, {
    "SET_TOTAL_PAGES_COUNT": (state, action) => {
        return {
            ...state,
            pageCount: action.payload.value,
        }
    },
    "SET_CURRENT_PAGE": (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    "SET_ACTIVE_FACILITITES": (state, action) => {
        return {
            ...state,
            activeFacilityList: action.payload.facilities
        }
    },
    "SET_SELECTED_FACILITY": (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload,
        }
    },
    "SET_SELECTED_REVIEW_FILTER": (state, action) => {
        return {
            ...state,
            selectedReviewFilter: action.payload
        }
    },
});

export default pmDashboardReducer;